<template>
  <div class="user-message-row">
    <div class="user-message-content">
      <p class="user-message-name">Ban</p>
      <div class="w-full text-left">
        <div class="user-message-bubble message-item markdown-content" v-html="content"></div>
        <div v-if="hasImages" class="user-upload-list user-upload-list--images">
          <a
            v-for="(item, index) in imageAttachments"
            :key="`img-${index}`"
            class="user-upload-image"
            :href="item.url || '#'"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="item.url" :alt="item.name || `image-${index + 1}`" />
          </a>
        </div>
        <div v-if="hasFiles" class="user-upload-list">
          <template v-for="(item, index) in fileAttachments">
            <a
              v-if="item.url"
              :key="`file-link-${index}`"
              class="user-upload-file"
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="user-file-icon" :class="getFileIconClass(item.name)">{{ getFileExtension(item.name) }}</span>
              <span class="user-file-name">{{ formatFileLabel(item, index) }}</span>
            </a>
            <span
              v-else
              :key="`file-text-${index}`"
              class="user-upload-file"
            >
              <span class="user-file-icon" :class="getFileIconClass(item.name)">{{ getFileExtension(item.name) }}</span>
              <span class="user-file-name">{{ formatFileLabel(item, index) }}</span>
            </span>
          </template>
        </div>
      </div>
      <div class="user-message-actions">
        <button
          type="button"
          class="user-copy-btn"
          aria-label="Sao chep"
          @click="$emit('copy', content)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
          </svg>
          Sao chép
        </button>
      </div>
    </div>
    <div class="user-message-avatar">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuperDocQuestionMessage',
  props: {
    content: {
      type: String,
      default: ''
    },
    imageAttachments: {
      type: Array,
      default: () => []
    },
    fileAttachments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasImages () {
      return Array.isArray(this.imageAttachments) && this.imageAttachments.length > 0
    },
    hasFiles () {
      return Array.isArray(this.fileAttachments) && this.fileAttachments.length > 0
    }
  },
  methods: {
    formatBytes (size) {
      if (!Number.isFinite(size) || size <= 0) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      const exponent = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1)
      const value = size / (1024 ** exponent)
      const digits = exponent === 0 ? 0 : 1
      return `${value.toFixed(digits)} ${units[exponent]}`
    },
    formatFileLabel (item, index) {
      const fileName = item?.name || `File ${index + 1}`
      const fileSize = this.formatBytes(Number(item?.size || 0))
      return `${fileName} (${fileSize})`
    },
    getFileExtension (name = '') {
      const extension = String(name).split('.').pop()
      return extension && extension !== name ? extension.slice(0, 4).toUpperCase() : 'FILE'
    },
    getFileIconClass (name = '') {
      const extension = this.getFileExtension(name).toLowerCase()
      if (extension === 'pdf') return 'user-file-icon--pdf'
      if (['doc', 'docx', 'txt', 'rtf'].includes(extension)) return 'user-file-icon--document'
      if (['xls', 'xlsx', 'csv'].includes(extension)) return 'user-file-icon--spreadsheet'
      if (['ppt', 'pptx'].includes(extension)) return 'user-file-icon--presentation'
      if (['zip', 'rar', '7z'].includes(extension)) return 'user-file-icon--archive'
      return 'user-file-icon--default'
    }
  }
}
</script>

<style scoped>
.user-message-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 8px;
}

.user-message-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  max-width: 88%;
}

.user-message-name {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 500;
  margin-right: 4px;
  margin-bottom: 0;
}

.user-message-bubble {
  margin-left: auto;
  width: fit-content;
  max-width: 100%;
  border-radius: 16px;
  border-top-right-radius: 0;
  padding: 12px 16px;
  box-shadow: 0 8px 18px rgba(59, 130, 246, 0.2);
  background: #3b82f6;
  color: #fff;
  font-size: 13px;
  line-height: 1.55;
  text-align: left;
  white-space: pre-wrap;
  word-break: normal;
  overflow-wrap: break-word;
  line-break: auto;
  hyphens: none;
}

.user-message-bubble :deep(*) {
  white-space: pre-wrap;
  word-break: normal;
  overflow-wrap: break-word;
  line-break: auto;
  hyphens: none;
}

.user-message-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
  margin-right: 4px;
}

.user-upload-list {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.user-upload-list--images {
  gap: 8px;
}

.user-upload-image {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.45);
  display: block;
}

.user-upload-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-upload-file {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #1e40af;
  background: rgba(255, 255, 255, 0.88);
  border-radius: 9999px;
  padding: 4px 8px;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-file-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 28px;
  height: 24px;
  border-radius: 5px;
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.user-file-icon--pdf { background: #ef4444; }
.user-file-icon--document { background: #2563eb; }
.user-file-icon--spreadsheet { background: #16a34a; }
.user-file-icon--presentation { background: #ea580c; }
.user-file-icon--archive { background: #64748b; }
.user-file-icon--default { background: #94a3b8; }

.user-file-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-copy-btn {
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 11px;
}

.user-copy-btn:hover {
  color: #2563eb;
  background: #eff6ff;
}

.user-message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #3b82f6;
}
</style>
